<script setup lang="ts">
import { Toast, type ToastServiceMethods, useToast } from 'primevue'
import { watch } from 'vue'
import { useUiStore } from '@/stores'
import { type UiStore } from '@/types'

const toast: ToastServiceMethods = useToast()

const uiStore: UiStore = useUiStore()

watch(
    () => uiStore.toast.id,
    (value: number) => {
        if (value) {
            toast.removeGroup('warn')
            toast.add({
                detail: uiStore.toast.detail,
                group: uiStore.toast.severity,
                life: 5000,
                severity: uiStore.toast.severity,
                summary: uiStore.toast.summary,
            })
        }
    },
)
</script>

<template>
    <div class="min-w-[350px] text-body-16 text-surface-800">
        <div class="mx-auto max-w-screen-xl overflow-hidden">
            <router-view />
        </div>

        <Toast
            group="info"
            :pt="{
                closeButton: {
                    autofocus: false,
                },
            }" />
        <Toast
            group="success"
            :pt="{
                closeButton: {
                    autofocus: false,
                },
            }" />
        <Toast
            group="warn"
            :pt="{
                closeButton: {
                    autofocus: false,
                },
            }" />
    </div>
</template>
